import { render, staticRenderFns } from "./OpcServerList.vue?vue&type=template&id=38b4ee3f&scoped=true"
import script from "./OpcServerList.vue?vue&type=script&lang=js"
export * from "./OpcServerList.vue?vue&type=script&lang=js"
import style0 from "./OpcServerList.vue?vue&type=style&index=0&id=38b4ee3f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b4ee3f",
  null
  
)

export default component.exports